<template>
  <div id="app">
    <div class="app-container">
      <Header></Header>
      <router-view/>
      <GoTop></GoTop>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style scope>
.app-container{
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue